import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerComplaintSmartComponent } from './borrower-complaint-smart/borrower-complaint-smart.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { AlertModule } from 'app/components/alert/alert.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    BorrowerComplaintSmartComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    AlertModule,
    MatProgressSpinnerModule,
    FormlyModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  exports: [
    BorrowerComplaintSmartComponent
  ]
})
export class BorrowerComplaintModule { }
